import {connect} from 'react-redux';

import {setContentPartnersAction} from './Redux/ContentPartnersActions';
import ContentPartnersContainer from './ContentPartnersContainer';
interface State {
    contentPartners:{
        data: {
            rows: [{ label: string, value: string }],
        }
        isLoading: boolean,
    };
}
export const mapState = (state: State) => {
    return {
        contentPartners: state.contentPartners,
    };
};

export const mapDispatch = {
    setContentPartners: setContentPartnersAction,
};

export default connect(mapState, mapDispatch)(ContentPartnersContainer);
